import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import HvacSubsections from './pages/HvacSubsections';
import ElectricalSubsections from './pages/ElectricalSubsections';
import DoorAutomationSubsections from './pages/DoorAutomationSubsections';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/hvac/:subsection" element={<HvacSubsections />} />
          <Route path="/electrical/:subsection" element={<ElectricalSubsections />} />
          <Route path="/door-automation/:subsection" element={<DoorAutomationSubsections />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;